<template>
  <div class="fullheight">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="container">
        <div class="navbar-brand">
          <a class="navbar-item" style="padding-top: 10px;">
            <img src="../../src/assets/img/cardiff-white-text-only.png" id="logo" height="28" alt="cardiff logo">
          </a>
        </div>
      </div>
    </nav>
    <div class="fullheight" id="appcontainer">
      <div class="columns fullheight is-centered">
        <div class="column" id="app-column"> 
          <transition :name='transition' mode="out-in">
            <AggLoading v-if="page == 0" key="p0" @next="incrementPage" :link="$route.params.code" :passw="$route.params.pass" :token="token"/>
            <AccountSelector v-if="page == 1" key="p1" @next="incrementPage" @doublenext="goToReport" :appnum="appnum" :accounts="accounts" :reports="reports" :pass="pass" :custid="customerId" :userdata="userdata" :files="files" :token="token" :plaidmodel="plaidmodel"/>
            <Account v-if="page == 2" key="p2" @next="incrementPage" @prev="decrementPage" :appnum="appnum" :resp="response" :account="account"/>
            <Report v-if="page == 3" key="p3" @next="incrementPage" @prev="decrementPage(this, 2)" :report="report"/>
          </transition>

        </div>
      </div>
    </div>
    <!-- <footer class="footer" style="margin-top: 60px;" v-if="page != 7">
      <div class="content has-text-centered">
          <p style="font-size: 0.675em; color: grey; margin-top: 10px;">© 2019 Commercial Finance & Leasing Bank of Cardiff, Inc</p>
      </div>
    </footer> -->
  </div>

</template>

<script>

import {AggLoading, AccountSelector, Account, Report, decisionwizard} from '@/components/aggregation'
export default {
  name: 'Agg',
  components: {
    AggLoading,
    AccountSelector,
    Account,
    Report
  },
  data () {
    return {
      transition: 'slide',
      page: 0,
      demo: false,
      customerId: null,
      model: {name: ''},
      finresult: false,
      accounts: null,
      reports: null,
      appnum: null,
      pass: null,
      response: {},
      account: {},
      report: {},
      token: null,
      userdata: null,
      files: null,
      plaidmodel: null
    }
  },
  methods: {
    incrementPage: function (pageData) {
      this.transition = 'slide'
      console.log(pageData)
      if (pageData.accounts){
        this.accounts = pageData.accounts
        this.reports = pageData.reports
        this.appnum = pageData.appnum
        this.customerId = pageData.custid
        if (pageData.tokenval){
          this.token = pageData.tokenval
          this.userdata = pageData.userdata
        }
        this.pass = pageData.pass
        this.files = pageData.files
        this.plaidmodel = pageData.plaidmodel
        console.log('we need to pass these accounts to the account selection page', this.accounts)
      }
      if (pageData.aggregation){
        this.response = pageData.aggregation.resp 
        this.account = pageData.aggregation.account
      }
      if (pageData.report){
        this.report = pageData.report
      }
      this.validate()
      this.page++
      window.scrollTo(0, 0)
    },
    goToReport: function (pageData) {
      this.transition = 'slide'
      console.log(pageData)
      if (pageData.report){
        this.report = pageData.report
      }
      this.validate()
      this.page+=2
      window.scrollTo(0, 0)
    },
    decrementPage: function (pageData, amount=1) {
      this.transition = 'slideb'
      this.page-=amount
      window.scrollTo(0, 0)
    },
    validate: function () {
      console.log(this.$route.params.code)
    }
  },
  mounted: function () {
    if (localStorage.getItem('authtoken')){
        this.token = localStorage.getItem('authtoken')
    }
    if (this.$route.params.token){
      this.token = this.$route.params.token
      localStorage.setItem('authtoken', this.token)
    }
    if (!this.demo) {
      return
    }
    const self = this
    setInterval(function () {
      if (self.page === 1) {
        self.page += 2
      } else if (self.page === 6 || self.page === 3) {
        self.page += 3
      } else if (self.page < 9) {
        self.page++
      }
    }, 3000)
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar .navbar-brand {
  text-align: center;
  display: block;
  width: 100%;
}

.navbar .navbar-brand > .navbar-item,
.navbar .navbar-brand .navbar-link {
  display: inline-block;
}
@media screen and (min-width: 767px), print {
  .mobile-only{
    display: none;
  }
  .fullheight{
    /* height: 100%; */
  }
  #app-column{
    padding: 50px 50px;
  }
}

@media screen and (max-width: 768px) {
  #cardiff-column{
    display: none;
  }
  #app-column{
    min-height: 100vh;
    padding-top: 50px;
  }
}

#cardiff-column{
  background: #f1f1f1;
  z-index: 1;
  padding-top: 100px;
  max-width: 280px;
}

#logo {
  /* max-width: 50%; */
  margin: auto;
  display: block;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
}

.next-button{
  margin-top: 10px;
}

.columns{
  margin-left: 0;
  margin-right: 0;
}

.no-margin {
  margin-bottom: 0px !important;
}
</style>
